import InAppEducationV4 from './InAppEducationV4'

export default InAppEducationV4
